import Token from 'vindi-ds-tokens';

export default {
  main: {
    backgroundColor: Token.color.functional.light['100'].value,
    padding: '1em',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  successMessage: {
    alignItems: 'center',
  },
  successMessageLogo: {
    height: '2.1875em',
    width: '9.375em',
    marginBottom: '2.5em',
  },
  title: {
    marginBottom: Token.spacing.small.value,
  },
  footer: {
    marginTop: Token.spacing.xs.value,
    marginBottom: Token.spacing.xs.value,
    color: Token.color.functional.dark['200'].value,
  },
  loginButton: {
    textDecoration: 'none',
  },
  loginButtonMobile: {
    textDecoration: 'none',
    width: '100%',
    margin: 0,
  },
};
